import React from "react";
import { Helmet } from "react-helmet";
//import _get from 'lodash/get';
import "../City/EditCity/style.css";
//import EmptyMessage from 'components/EmptyMessage/EmptyMessage';
import Col from "react-bootstrap/Col";
import Footer from "components/Footer/Footer";
//import Button from 'components/Button/Button';
//import ChannelImage from 'Assets/city-hero.png';

import {
  apiUrl,
  user_entity_uuid,
  user_access_token,
  user_access_level,
  user_Status_Ver,
  myHeaders_Auth_With_Cache_Control,
} from "Api/Api";
import axios from "axios";
// import { origin } from 'utils/Helper';

import FullPageSpinner from "components/FullPageSpinner/FullPageSpinner";
import { withRouter, NavLink } from "react-router-dom";
import { local_routes } from "utils/Routes";
import home from "Assets/home.svg";
import { Redirect } from "react-router-dom";
import PechaKuchaInfo from "pages/ManagePechaKucha/ManagePechaKuchaTabs/PechaKuchaInfo";
import PechaKuchaStats from "pages/ManagePechaKucha/ManagePechaKuchaTabs/PechaKuchaStats";
import PechaKuchaComments from "pages/ManagePechaKucha/ManagePechaKuchaTabs/PechaKuchaComments";
import PechaKuchaUsers from "pages/ManagePechaKucha/ManagePechaKuchaTabs/PechaKuchaUsers";
import PechaKuchaChannels from "pages/ManagePechaKucha/ManagePechaKuchaTabs/PechaKuchaChannels";
import PechaKuchaJobs from "pages/ManagePechaKucha/ManagePechaKuchaTabs/PechaKuchaJobs";
import PechaKuchaTeams from "./ManagePechaKuchaTabs/PechaKuchaTeams";
import PechaKuchaLocations from "./ManagePechaKuchaTabs/PechaKuchaLocations";

class ManagePechaKucha extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageLoader: true,
      allowed: true,
      currentTab: "none",
    };

    this.user_data = {};
  }

  componentDidUpdate(prevProps) {
    let {
      location: { pathname },
    } = this.props;

    if (prevProps.location.pathname === pathname) return;
    this.routeChanged();
  }

  routeChanged() {
    if (this.props.match.params.otherpage) {
      if (this.props.match.params.otherpage === "main") {
        this.setState({ currentTab: "main" });
      } else if (this.props.match.params.otherpage === "comments") {
        this.setState({ currentTab: "comments" });
      } else if (this.props.match.params.otherpage === "stats") {
        this.setState({ currentTab: "stats" });
      } else if (this.props.match.params.otherpage === "users") {
        this.setState({ currentTab: "users" });
      } else if (this.props.match.params.otherpage === "jobs") {
        this.setState({ currentTab: "jobs" });
      } else if (this.props.match.params.otherpage === "teams") {
        this.setState({ currentTab: "teams" });
      } else if (this.props.match.params.otherpage === "channels") {
        this.setState({ currentTab: "channels" });
      } else if (this.props.match.params.otherpage === "cities") {
        this.setState({ currentTab: "cities" });
      } else {
        // bad tab!
        this.setState({ currentTab: null });
      }
    } else {
      // no tab!
      this.setState({ currentTab: null });
    }
  }

  componentDidMount = async function () {
    window.scrollTo(0, 0);

    if (!user_access_token || user_Status_Ver !== "1") {
      this.setState({ allowed: false });
      return;
    }

    let allowed = false;
    if (user_access_level === "admin") {
      // allowed
      allowed = true;
    }

    if (!allowed) {
      console.error("User not allowed to manage channel");
      this.setState({ allowed: false });
      return;
    }

    try {
      let [user_data_response] = await Promise.all([
        //axios.get(`${apiUrl}organizations/${org_friendly_url}`, myHeaders_With_Cache_Control),
        axios.get(
          `${apiUrl}users/${user_entity_uuid}`,
          myHeaders_Auth_With_Cache_Control
        ),
        // axios.get(`${apiUrl}users/${user_entity_uuid}/locations.audience?filter_obj=${encodeURIComponent('{"resident_integer":{"gte":1}}')}`, myHeaders_With_Cache_Control),
      ]);
      this.user_data = user_data_response.data;
      // this.user_data.locations = user_location_data_response.data;
      // org_data_response.data.channels = channels_data_response.data;

      this.setState({ pageLoader: false });
    } catch (err) {
      this.setState({ pageLoader: false });
      return;
    }

    this.routeChanged();
  };

  render() {
    const { currentTab, allowed, pageLoader } = this.state;

    if (!allowed) {
      return <Redirect to="/404" />;
    }

    if (!currentTab) {
      return <Redirect to={`${local_routes.managepechakucha}/main`} />;
    }

    if (pageLoader) {
      return <FullPageSpinner />;
    }

    return (
      <React.Fragment>
        <Helmet>
          <title>Manage PechaKucha Website</title>
          <meta name="robots" content="noindex" />
        </Helmet>
        <React.Fragment>
          <div className="main-section editCityData">
            <div className="editCityBg">
              <div className="container editCityMenu">
                <Col lg={12} className="pad-mb0 pad0">
                  <div>
                    <div
                      className="sub-menu-nav"
                      style={{ borderBottom: "medium none" }}
                    >
                      <ul>
                        <li>
                          <NavLink
                            activeStyle={{ color: "#D12F50" }}
                            to={`${local_routes.managepechakucha}/main`}
                          >
                            INFO
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            activeStyle={{ color: "#D12F50" }}
                            to={`${local_routes.managepechakucha}/comments`}
                          >
                            COMMENTS
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            activeStyle={{ color: "#D12F50" }}
                            to={`${local_routes.managepechakucha}/stats`}
                          >
                            STATS
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            activeStyle={{ color: "#D12F50" }}
                            to={`${local_routes.managepechakucha}/teams`}
                          >
                            TEAMS
                          </NavLink>
                        </li>
                        {/*<li><NavLink activeStyle={{ color: "#D12F50" }} to={`${local_routes.managepechakucha}/jobs`}>JOBS</NavLink></li>*/}

                        <li>
                          <NavLink
                            activeStyle={{ color: "#D12F50" }}
                            to={`${local_routes.managepechakucha}/users`}
                          >
                            USERS
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            activeStyle={{ color: "#D12F50" }}
                            to={`${local_routes.managepechakucha}/channels`}
                          >
                            CHANNELS
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            activeStyle={{ color: "#D12F50" }}
                            to={`${local_routes.managepechakucha}/cities`}
                          >
                            CITIES
                          </NavLink>
                        </li>
                      </ul>
                    </div>
                    {this.state.currentTab === "main" && (
                      <PechaKuchaInfo
                        user_data={this.user_data}
                        {...this.props}
                      />
                    )}
                    {this.state.currentTab === "comments" && (
                      <PechaKuchaComments
                        user_data={this.user_data}
                        {...this.props}
                      />
                    )}
                    {this.state.currentTab === "stats" && (
                      <PechaKuchaStats
                        user_data={this.user_data}
                        {...this.props}
                      />
                    )}
                    {this.state.currentTab === "jobs" && (
                      <PechaKuchaJobs
                        user_data={this.user_data}
                        {...this.props}
                      />
                    )}
                    {this.state.currentTab === "teams" && (
                      <PechaKuchaTeams
                        user_data={this.user_data}
                        {...this.props}
                      />
                    )}
                    {this.state.currentTab === "users" && (
                      <PechaKuchaUsers
                        user_data={this.user_data}
                        {...this.props}
                      />
                    )}
                    {this.state.currentTab === "channels" && (
                      <PechaKuchaChannels
                        user_data={this.user_data}
                        {...this.props}
                      />
                    )}
                    {this.state.currentTab === "cities" && (
                      <PechaKuchaLocations
                        user_data={this.user_data}
                        {...this.props}
                      />
                    )}
                  </div>
                </Col>
              </div>
            </div>
            {/* Banner sub navigation starts */}
            {/* Banner sub navigation ends */}
            <Footer
              homeImg={home}
              homeImgRef="/"
              breadcrumbSubPage="Manage PechaKucha"
            />
          </div>
        </React.Fragment>
      </React.Fragment>
    );
  }
}

export default withRouter(ManagePechaKucha);
